import { IconProps } from "./";
import Icon from "./assets/home_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Home(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
